module.exports = __webpack_public_path__ + "static/media/mapimages16.33bed7ac.svg";